import { RECEIVE_PAGE } from '../actions'

export const DEFAULT_PAGE = 'defaultPage'

let defaultPage = {
    id: '',
    content: {
        rendered: ''
    },
    title: {
        rendered: ''
    },
    slug: '',
    featured_media: '',
    cmb2: {
        _home_feature_metabox: {
            _home_feature_group: [{
                title: '',
                text: '',
                image_id: 0,
                next: '',
            }],
        },
        _home_feature_last_metabox: {
            _home_feature_last_title: '',
            _home_feature_last_text: '',
            _home_feature_last_image: '',
            _home_feature_last_image_id: 0,
            _home_feature_last_action_text: '',
            _home_feature_last_action_link: '',
        },
        _home_feature_training_metabox: {
            _home_feature_training_action_link: '',
            _home_feature_training_action_text: '',
            _home_feature_training_show: '',
            _home_feature_training_text: '',
        },
    },
};

let defaultState = {
    [DEFAULT_PAGE]: defaultPage
};

export default function pages(state = defaultState, action) {
    switch(action.type) {
        case RECEIVE_PAGE:
            const { pageName, page } = action.payload

            return Object.assign({}, state, {
                [pageName]: page
            });

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/pages.js